export const generateConfirmedValues = (confirmedValues: string[]) => {
  return confirmedValues.map((x) => `[${x}]`).join(' ');
};
